export class Usuario {

  private id:           number;
  private nome:         string;
  private senha:        string;
  private tipo:         string;
  private associado:    number;
  private data_inc:     string;
  private status:       string;
  private cpf:          string;
  private cep:          string;
  private endereco:     string;
  private nro_ender:    string;
  private cpl_ender:    string;
  private bairro:       string;
  private municipio:    number;
  private nome_cid:     string;
  private sexo:         string;
  private email:        string;
  private data_nasc:    string;
  private telefone:     string;
  private celular:      string;
  private est_impacto:  string;

  constructor ( ) {}

  public toJSON() {
    return {
      id:          this.id,
      nome:        this.nome,
      senha:       this.senha,
      tipo:        this.tipo,
      associado:   this.associado,
      data_inc:    this.data_inc,
      status:      this.status,
      cpf:         this.cpf,
      cep:         this.cep,
      endereco:    this.endereco,
      nro_ender:   this.nro_ender,
      cpl_ender:   this.cpl_ender,
      bairro:      this.bairro,
      municipio:   this.municipio,
      nome_cid:    this.nome_cid,
      sexo:        this.sexo,
      email:       this.email,
      data_nasc:   this.data_nasc,
      telefone:    this.telefone,
      celular:     this.celular,
      est_impacto: this.est_impacto
    };
  }

  public toClass(usuario) {
    this.id          = usuario.id;
    this.nome        = usuario.nome;
    this.senha       = usuario.senha;
    this.tipo        = usuario.tipo;
    this.associado   = usuario.associado;
    this.data_inc    = usuario.data_inc;
    this.status      = usuario.status;
    this.cpf         = usuario.cpf;
    this.cep         = usuario.cep;
    this.endereco    = usuario.endereco;
    this.nro_ender   = usuario.nro_ender;
    this.cpl_ender   = usuario.cpl_ender;
    this.bairro      = usuario.bairro;
    this.municipio   = usuario.municipio;
    this.nome_cid    = usuario.nome_cid;
    this.sexo        = usuario.sexo;
    this.email       = usuario.email;
    this.data_nasc   = usuario.data_nasc;
    this.telefone    = usuario.telefone;
    this.celular     = usuario.celular;
    this.est_impacto = usuario.est_impacto;
  }
}
